// Text from the document inside a message: in straight double quotes, with any
// such quote in it turned into ”, so the debug log can cut out every quoted
// part exactly and keep the rest of the message (D-47).
export const quote = (s: string): string => `"${s.replace(/"/g, '”')}"`;
